<template>
  <div class="annular-pie" :id="id"></div>
</template>

<script type="text/ecmascript-6">
import AnnularPie from './AnnularPie.js'
export default AnnularPie
</script>

<style lang="scss">
@import "AnnularPie.scss";
</style>



// WEBPACK FOOTER //
// src/components/echarts/annularPie/AnnularPie.vue